import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardContainerModule } from '@content-platform/reusable-ui/card';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { AdAuthGuard } from '@content-platform/web-angular-shared-util-auth';
import { guards } from '../guards';

@NgModule({
  declarations: [DashboardComponent],
  imports: [CommonModule, CardContainerModule, DashboardRoutingModule],
  providers: [AdAuthGuard, ...guards],
  exports: [DashboardComponent]
})
export class DashboardModule {}
